/**
 * @file hybrid模块入口
 * old hybrid -> hybrid
 */
import autoPlay from './autoPlay';
import browser from './browser';
import msg from './msg';
import schema from './schema';
import storage from './storage';
import user from './user';
import util from './util';
import initWXConf from './wx';

export {
  autoPlay,
  browser,
  msg,
  schema,
  storage,
  user,
  util,
  initWXConf,
};

export default {
  autoPlay,
  browser,
  msg,
  schema,
  storage,
  user,
  util,
  initWXConf,
};
